// ### user
export const USER_DASHBOARD_REQUEST = "USER_DASHBOARD_REQUEST";
export const USER_DASHBOARD_SUCCESS = "USER_DASHBOARD_SUCCESS";
export const USER_DASHBOARD_FAIL = "USER_DASHBOARD_FAIL";

// ### course
export const COURSE_DASHBOARD_REQUEST = "COURSE_DASHBOARD_REQUEST";
export const COURSE_DASHBOARD_SUCCESS = "COURSE_DASHBOARD_SUCCESS";
export const COURSE_DASHBOARD_FAIL = "COURSE_DASHBOARD_FAIL";

// reset
export const DASHBOARD_ERROR_RESET = "DASHBOARD_ERROR_RESET";
